
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1 64.1c0 1.8.6 3.5 2 4.7l57.8 57.1c1.4 1.3 2.9 2.1 4.7 2.1 1.8 0 3.4-.6 4.8-2.1 1.4-1.3 2-2.9 2-4.7V91H120c1.8 0 3.4-.6 4.8-2.1 1.4-1.3 2-2.9 2-4.7V43.8c0-1.8-.6-3.5-2-4.7-1.4-1.3-2.9-2.1-4.8-2.1H72.5V6.8c0-1.8-.6-3.5-2-4.7S67.6 0 65.7 0c-1.8 0-3.4.6-4.7 2.1L3.2 59.2C1.8 60.6 1 62.3 1 64.1z"}})])
          )
        }
      }
    